import {createContext, useContext} from 'react'
import type {FilterQueryRequest} from '../filter-request'
import type {FilterProvider} from '../types'

interface FilterQueryContext {
  clearFilter: () => void
  filterQuery: FilterQueryRequest
  filterProviders: Record<string, FilterProvider>
  forceReparse: (cursor?: number, simpleReparse?: boolean) => void
  rawFilter: string
  updateFilter: (unparsedFilter: string, updateCursorIndex?: boolean | number, shouldUpdate?: boolean) => void
}

export const FilterQueryContext = createContext<FilterQueryContext | undefined>(undefined)

export const useFilterQuery = () => {
  const context = useContext(FilterQueryContext)
  if (!context) {
    throw new Error('useFilterQuery must be used inside a FilterQueryContext')
  }

  return context
}

try{ FilterQueryContext.displayName ||= 'FilterQueryContext' } catch {}